import { useLocalSearchParams } from 'expo-router';
import { WorkoutProgress } from '~/workout/components/workout-progress/WorkoutProgress';

export default function WorkoutProgressPage() {
  const { id } = useLocalSearchParams<{ id: string }>();

  return <WorkoutProgress workoutNiceId={id!} />;
}
